module.exports = __webpack_public_path__ + "static/media/flyerPinamar.ebb180af.webp";